<template>
  <div class="back">
    <div class="back_image" ref="homePage">
      <!-- 入口按钮组合 -->
      <div class="videoDiv">
        <video controls class="video_d" autoplay>
          <source src="http://119.36.80.221:8081/hazard/upload/保康县应急演练1280720.mp4" type="video/mp4" />
        </video>
      </div>
      <!-- 返回首页Btn -->
      <div class="indexBtn" @click="toIndex">
        <el-button type="warning" icon="el-icon-s-home" size="mini" round>返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {},
  data() {
    return {
      clientHeight: ""
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
    },
    toIndex(){
      this.$router.push({ path: "/pad_index" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.back_image {
  width: 100%;
  background-image: url("../../assets/images/padImage/indexBacGround.jpg");
  background-size: 100% 100%;
}
.index_btn_video {
  width: 100%;
  height: 100%;
}
.videoDiv {
  width: 90%;
  height: 60%;
  margin: 0 auto;
  padding-top: 10%;
}
.video_d {
  width: 100%;
  height: 100%;
}
.indexBtn {
  position: fixed;
  top: 5%;
  right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/pad/pad_video.vue